import { ITopicsSDK } from '@1js/cortex-topics-bootstrapper';

let topicsSdk: ITopicsSDK | undefined = undefined;

/**
 * Returns the already initialized Topics SDK in a synchronous way.
 * If it hasn't been initialized it returns undefined.
 * This is meant to be used in topic-specific code where we know the SDK has been initialized.
 */
export function getTopicsSdk(): ITopicsSDK | undefined {
    return topicsSdk;
}

export function setTopicsSdk(sdk: ITopicsSDK): void {
    topicsSdk = sdk;
}
